<app-review-wrapper title="Details" [complete]="!!campaignDetails.campaignName" (onEdit)="navigateToUrl()">
  <dl class="bk-kv rs__kv">
    <dt>Name</dt>
    <dd [class.rs__empty]="!campaignDetails.campaignName">{{ campaignDetails.campaignName || "Not named yet" }}</dd>

    <dt>Description</dt>
    <dd [class.rs__empty]="!campaignDetails.description">{{ campaignDetails.description || "No description" }}</dd>

    <dt>Goals</dt>
    <dd>
      @if (goals.length) {
        <ul class="rs__list">
          @for (goal of goals; track $index) {
            <li>{{ goal }}</li>
          }
        </ul>
      } @else {
        <span class="rs__empty">No goals yet</span>
      }
    </dd>
  </dl>
</app-review-wrapper>
